import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { ProfileAvatarConnected } from "PFApp/components/profile_avatar_connected";
import { Inline, Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { useTranslation } from "react-i18next";

export const ActivityCreator = () => {
  const activity = useCurrentActivity();
  const { t } = useTranslation("activities", { keyPrefix: "show.details" });

  return (
    <Stack qaId="ActivitySummary-Creator">
      <Typography variant="bodyBold">{t("creator")}</Typography>
      {/* fixme make the Profile inline component */}
      <Inline alignItems="center" gap="spacingSm">
        <ProfileAvatarConnected profile={activity.profile} size={24} />
        <Typography variant="bodyButtons">{getProfileName(activity.profile)}</Typography>
      </Inline>
    </Stack>
  );
};
